module.exports = __webpack_public_path__ + "img/154.fc74ad6e.jpg";